export default __webpack_public_path__ + "static/atmospheric_pressure_and_isotherms-90ea657bc26ace67e89adb20e14fd49d.jpg";